import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
import { FinishTypeOption, QuantityCalculationMethodOption } from '@/utils/constants';

export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    },
    applicableYN: function() {
      return this.$store.getters['editor/value']('applicableYN');
    },
    finish: function() {
      const finishID = this.$store.getters['editor/value']('finishID');
      return finishID && this.$store.getters['finish/getLoadedItemByID'](finishID);
    },
    finishType: function() {
      return this.finish && this.$store.getters['finishType/getLoadedItemByID'](this.finish.finishTypeID);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'LinkDomainProductGroupFinish',
    returnTo: 'LinkDomainProductGroupFinishes'
  }),
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    isFabricWidthFactorRequired() {
      const finishType = this.finishType;
      return this.applicableYN && !!finishType && finishType.fabricWidthFactorRequiredYN;
    },
    isHeadingHeightRequired() {
      const finish = this.finish;
      const finishType = this.finishType;
      return !!finish && !!finishType && finishType.finishTypeOption === FinishTypeOption.Fixture;
    },
    isExtraFabricHeightApplicable() {
      const finishType = this.finishType;
      return this.applicableYN && !!finishType && finishType.extraFabricHeightApplicableYN;
    },
    isExtraFabricWidthApplicable() {
      const finishType = this.finishType;
      return this.applicableYN && !!finishType && finishType.extraFabricWidthApplicableYN;
    },
    showQuantityFormula() {
      const finishType = this.finishType;
      if (!this.applicableYN || !finishType) {
        return false;
      }
      const method = finishType.calculationMethodOption;
      return method === QuantityCalculationMethodOption.Formula || method === QuantityCalculationMethodOption.Pleats;
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
